import {Component, Vue} from 'vue-property-decorator'

/** Reliable width for JS layout (wheel, charts). innerWidth can be 0 on some mobile first paints until layout. */
function readViewportWidth(): number {
  if (typeof window === 'undefined') {
    return Number(process.env.VUE_APP_LARGE_SCREEN) || 1024
  }

  const vv = window.visualViewport?.width
  const inner = window.innerWidth
  const docEl = document.documentElement?.clientWidth
  const bodyW = document.body?.clientWidth
  const w = Math.max(vv ?? 0, inner || 0, docEl || 0, bodyW || 0)

  if (w > 0) {
    return Math.round(w)
  }

  return Number(process.env.VUE_APP_MOBILE_M_SCREEN) || 375
}

@Component
export class MixinScreenSize extends Vue {
  screenWidth = readViewportWidth()

  get isMobileS() {
    return this.screenWidth <= Number(process.env.VUE_APP_MOBILE_S_SCREEN)
  }

  get isMobileM() {
    return this.screenWidth <= Number(process.env.VUE_APP_MOBILE_M_SCREEN)
  }

  get isMobileL() {
    return this.screenWidth <= Number(process.env.VUE_APP_MOBILE_L_SCREEN)
  }

  get isMobile() {
    return this.screenWidth <= Number(process.env.VUE_APP_SMALL_SCREEN)
  }

  get isTablet() {
    return (
      this.screenWidth > Number(process.env.VUE_APP_SMALL_SCREEN) &&
      this.screenWidth <= Number(process.env.VUE_APP_MEDIUM_SCREEN)
    )
  }

  get isLessThanTablet() {
    return this.screenWidth < Number(process.env.VUE_APP_MEDIUM_SCREEN)
  }

  get isSmallDesktop() {
    return (
      this.screenWidth > Number(process.env.VUE_APP_MEDIUM_SCREEN) &&
      this.screenWidth <= Number(process.env.VUE_APP_LARGE_SCREEN)
    )
  }

  get isLargeDesktop() {
    return this.screenWidth > Number(process.env.VUE_APP_EXTRA_LARGE_SCREEN)
  }

  get isDesktop() {
    return this.screenWidth > Number(process.env.VUE_APP_LARGE_SCREEN)
  }

  get showSwiperArrows() {
    return this.screenWidth >= Number(process.env.VUE_APP_SWIPER_ARROWS_SCREEN)
  }

  created() {
    window.addEventListener('resize', this.resizeEvent)
    window.addEventListener('orientationchange', this.resizeEvent)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.resizeEvent)
    }
    this.resizeEvent()
  }

  mounted() {
    this.$nextTick(() => {
      this.resizeEvent()
      requestAnimationFrame(() => {
        this.resizeEvent()
      })
    })
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEvent)
    window.removeEventListener('orientationchange', this.resizeEvent)
    if (typeof window !== 'undefined' && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.resizeEvent)
    }
  }

  resizeEvent() {
    this.screenWidth = readViewportWidth()
  }
}
